import { render, staticRenderFns } from "./ParticipantRelapseScheduleStatusComponent.vue?vue&type=template&id=45fa41ea&scoped=true&"
import script from "./ParticipantRelapseScheduleStatusComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantRelapseScheduleStatusComponent.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantRelapseScheduleStatusComponent.vue?vue&type=style&index=0&id=45fa41ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa41ea",
  null
  
)

export default component.exports